import classNames from "classnames";

import styles from "./Footer.module.css";
import { Button } from "../Button";
import { useContext } from "react";
import UiContext from "../../context/UiContext";

export const Footer = () => {
  const { state, openPicker, openModal } = useContext(UiContext);

  const footerClass = classNames({
    [styles.footer]: true,
    [styles["-hidden"]]:
      state?.picker?.isOpen || state?.modal?.isOpen || state?.dialog?.isOpen,
  });

  // Footer
  return (
    <div className={footerClass}>
      <div className={styles.inner}>
        <Button
          width="full"
          size="large"
          color="blue"
          emoji="💬"
          onClick={() => openModal({ name: "entries" })}
        >
          Sjå innspel
        </Button>
        <Button
          width="full"
          size="large"
          color="pink"
          emoji="📍"
          onClick={openPicker}
        >
          Legg til
        </Button>
      </div>
    </div>
  );
};
